

jQuery(function($){

	if( $('.custom-lightbox__overlay').length ) {

		$(".js-open-floorplan").click(function() {
			$("body").addClass('js-custom-lightbox-open');
		});

		$(".custom-lightbox__overlay").click(function() {
			$("body").removeClass('js-custom-lightbox-open');
		});

		$(".custom-lightbox__close").click(function() {
			$("body").removeClass('js-custom-lightbox-open');
		});

		$(document).on('keydown', function(event) {
			if (event.key == "Escape") {
				$("body").removeClass('js-custom-lightbox-open');
			}
		});

	}

});


